import React, { createContext, useState, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

// Create a context to manage toast data
const ToastContext = createContext();

// Custom hook to use the toast context
export const useToasts = () => useContext(ToastContext);

// ToastProvider component to provide context to the app
export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  // Function to show a toast
  const showToast = useCallback((message, type = 'success') => {
    const newToast = { message, type, id: Date.now() };
    setToasts((prevToasts) => [...prevToasts, newToast]);

    // Remove toast after 5 seconds
    setTimeout(() => {
      setToasts((prevToasts) =>
        prevToasts.filter((toast) => toast.id !== newToast.id)
      );
    }, 5000);
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, showToast }}>
      {children}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};